<template>
  <div :style="{'background-image': `url(${bgImg})`}" class="carousel-container">
    <!-- 轮播内容 -->
    <div class="p-20 text-center">
      <div class="flex space-between col-center p-b-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">{{ type == 1 ? '合同签订' : '回款明细' }}</span>
      </div>

      <div v-show="index === currentIndex" v-for="(item, index) in carouselData" :key="index">
        <div>
          <div class="flex col-center">
            <img v-if="item.type == 1" alt="" class="w-48 h-48 m-r-10 m-t-4" src="@/assets/icon/employeeKanban/hetong.png">
            <img v-if="item.type == 2" alt="" class="w-48 h-48 m-r-10 m-t-4" src="@/assets/icon/employeeKanban/huikuan.png">
            <span class="font-28 dis-in-b ellipsis-1">{{ item.name }}</span>
          </div>
          <div class="font-24 m-l-58 text-left m-b-2">{{ item.type == 1 ? '签订时间' : '回款时间' }}：{{ moment(item.time).format('YYYY-MM-DD') }}</div>
          <div v-if="item.type == 2" class="font-24 m-l-58 text-left">客户：{{ item.customer }}</div>
        </div>
        <div class="cor-1C2ECC m-t-14 m-b-14">
          <span class="font-72 font-weight-700">{{ item.amount }}</span>
          <span class="font-28">元</span>
          <div class="font-28">{{ item.type == 1 ? '合同金额' : '回款金额' }}</div>
        </div>
        <div class="font-24 cor-66 text-center">共{{ item.type == 1 ? '签订合同' : '回款' }}<span>{{ item.totalNum }}</span>笔，总金额<span>{{ item.totalAmount }}</span>元
        </div>
      </div>
    </div>

    <!-- 左右箭头按钮 -->
    <template v-if="carouselData.length > 0">
      <img alt="" class="prev-btn" src="@/assets/icon/employeeKanban/left.png" @click="prevSlide">
      <img alt="" class="next-btn" src="@/assets/icon/employeeKanban/right.png" @click="nextSlide">
    </template>

    <!-- 当前页码指示器 -->
    <div class="indicator" v-if="carouselData.length > 0">
      <span class="current">{{ currentIndex + 1 }}</span>/<span class="total">{{ carouselData.length }}</span>
    </div>

    <div v-if="carouselData.length == 0" class="width-50 m-auto flex-col row-center col-center">
      <img alt="" class="w-330 h-196" src="@/assets/icon/employeeKanban/noData.png">
      <div class="font-28 cor-66">暂无数据</div>
    </div>
  </div>
</template>

<script>
import TitleLogo from "@/components/TitleLogo.vue";
import moment from "moment";

export default {
  name: 'ContractCarousel',
  computed: {
    moment() {
      return moment
    }
  },
  components: {TitleLogo},
  props: {
    carouselData: {
      type: Array,
      default: []
    },
    bgImg: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      currentIndex: 0,
      autoplayInterval: null, // 存储定时器引用
      autoplayEnabled: true, // 控制是否启用自动播放
      loading: false, // 加载状态
    }
  },
  mounted() {
  },
  beforeUnmount() {
    // this.stopAutoplay(); // 清理定时器
  },
  methods: {
    // 开始自动播放
    startAutoplay() {
      if (!this.autoplayEnabled || this.carouselData.length === 0) return;
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, 3000); // 每3秒切换一次
    },
    // 停止自动播放
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.carouselData.length;

      // this.resetAutoplay(); // 重置自动播放计时器
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.carouselData.length) % this.carouselData.length;
      // this.resetAutoplay(); // 重置自动播放计时器
    },
    // 重置自动播放计时器（用户手动操作时）
    resetAutoplay() {
      this.stopAutoplay();
      setTimeout(() => {
        if (this.autoplayEnabled) {
          this.startAutoplay();
        }
      }, 1000); // 手动操作后延迟1秒再开始自动播放
    },

    // 切换自动播放开关
    toggleAutoplay() {
      this.autoplayEnabled = !this.autoplayEnabled;
      if (this.autoplayEnabled) {
        this.startAutoplay();
      } else {
        this.stopAutoplay();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.carousel-container {
  position: relative;
  width: 100%;
  min-height: 350px;
  margin-bottom: 16px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  //background-image: url("~@/assets/icon/employeeKanban/hetongBg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.prev-btn, .next-btn {
  position: absolute;
  top: 38%;
  width: 48px;
  height: 110px;
  border-radius: 16px;
}

.prev-btn {
  left: 10px;
}

.next-btn {
  right: 10px;
}

.indicator {
  position: absolute;
  bottom: 16px;
  right: 16px;
  border: 2px solid #ffffff;
  border-radius: 40px;
  padding: 8px 16px;
  font-size: 24px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;
}

.current {
  font-weight: bold;
  color: #1a56ff;
}
</style>
